<template>
  <n-button v-bind="attrs" :loading="loading" @on-click="onClick" />
</template>

<script>
import { isFunction, isUndefined } from 'lodash-es';
import ICON from '@/constant/icon';

export default {
  name: 'NbCustom',
  props: {
    type: String,
    size: String,
    icon: String,
    customIcon: String,
    text: String,
    long: Boolean,
    ghost: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    attrs() {
      return {
        ...this.$props,
        customIcon: isUndefined(this.customIcon) ? ICON[this.text] || ICON.info : this.customIcon,
      };
    },
  },
  methods: {
    onClick() {
      if (this.loading) return;
      const cb = this.$listeners['on-click'];
      if (!isFunction(cb)) return;

      this.loading = true;
      const ret = cb() || {};
      if (isFunction(ret.finally)) {
        ret.finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>
